import Post from 'utils/fetch/Post';
import apiUrl from 'utils/apiUrl/apiUrl';

export const changeStateCashout = (state: string, record_id: string | number): void => {
    new Post({
        params: {aasm_sate: state},
        url: apiUrl(`/cashouts/${record_id}/change_state`)
    })
        .execute()
        .then(response => {
            if (response.ok) {
                window.location.reload();
            }
        });
};
